import OperatingModeLookupResourcePagingResultModel from '../../generated/types/model/resource/OperatingModeLookupResourcePagingResultModel';

export default class OperatingModeLookupResourcePagingResultViewModel extends OperatingModeLookupResourcePagingResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
